import { render } from "./ClientEstadoCuentaProveedor.vue?vue&type=template&id=b4620e78&scoped=true"
import script from "./ClientEstadoCuentaProveedor.vue?vue&type=script&lang=js"
export * from "./ClientEstadoCuentaProveedor.vue?vue&type=script&lang=js"

import "./ClientEstadoCuentaProveedor.vue?vue&type=style&index=0&id=b4620e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4620e78"]])

export default __exports__